// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__21kTT","approved":"Status_approved__2OJ6A","rejected":"Status_rejected__wkGDv","expired":"Status_expired__34Q8W","label":"Status_label__1ojiM"};